import { useState } from 'react';
import Box from '@mui/material/Box';
import { PictureAsPdf as PdfIcon, Image as ImageIcon, Videocam as VideoIcon, InsertDriveFile as FileIcon } from '@mui/icons-material';

export function FileThumbnail({ fileType, fileUrl, fileName, type, size = 200, thumbnailUrl }) {
  const [thumbnailError, setThumbnailError] = useState(false);
  
  const isPDF = fileType?.toLowerCase().includes('pdf') || fileName?.toLowerCase().endsWith('.pdf');
  const isImage = fileType?.toLowerCase().includes('image') || 
                  fileName?.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/i);
  const isVideo = fileType?.toLowerCase().includes('video') || 
                  fileName?.toLowerCase().match(/\.(mp4|avi|mov|wmv)$/i);

  // Show thumbnail for PDFs if available
  if (isPDF && thumbnailUrl && !thumbnailError) {
    return (
      <Box
        component="img"
        src={thumbnailUrl}
        alt={fileName}
        onError={() => setThumbnailError(true)}
        sx={{
          width: size,
          height: size,
          objectFit: 'cover',
          borderRadius: 1,
          bgcolor: '#F2F2F2',
          border: '1px solid #e0e0e0'
        }}
      />
    );
  }

  if (isImage && fileUrl) {
    return (
      <Box
        component="img"
        src={fileUrl}
        alt={fileName}
        sx={{
          width: size,
          height: size,
          objectFit: 'cover',
          borderRadius: 1,
          bgcolor: '#F2F2F2'
        }}
      />
    );
  }

  if (isVideo && fileUrl) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#000',
          borderRadius: 1,
          position: 'relative'
        }}
      >
        <Box
          component="video"
          src={fileUrl}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
        <VideoIcon sx={{ 
          position: 'absolute', 
          fontSize: size / 4, 
          color: 'white',
          opacity: 0.7
        }} />
      </Box>
    );
  }

  // Default icon display
  return (
    <Box
      sx={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#F2F2F2',
        borderRadius: 1
      }}
    >
      {isPDF ? (
        <PdfIcon sx={{ fontSize: size / 2, color: '#D32F2F' }} />
      ) : (
        <FileIcon sx={{ fontSize: size / 2, color: '#757575' }} />
      )}
    </Box>
  );
}

